import script from "./AppLayoutMain.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppLayoutMain.vue?vue&type=script&lang=ts&setup=true"

import "./AppLayoutMain.vue?vue&type=style&index=0&id=672c3bea&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-672c3bea"]])

export default __exports__